import { CustomCellRendererProps } from "ag-grid-react";
import { DECIMAL_2 } from "presentation/utils/numberUtil";
import { defineColumn, transferRowDataInternal } from "presentation/view/components/TableWrapper/BasicTableConstants";
import { EstimatedUnbillFigureConstant } from "./EstimatedUnbillFigureConstant";

const ESTIMATED_UNBILL_FIGURE_CONSTANT = EstimatedUnbillFigureConstant.Table;
let dateFieldList: string[] = [];
let dateTimeFieldList: string[] = [];
export const INITIAL_ESTIMATED_UNBILL_FIGURE_COL_DEF: any[] = [

    {
        headerName: ESTIMATED_UNBILL_FIGURE_CONSTANT.YEAR,
        field: "year",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: ESTIMATED_UNBILL_FIGURE_CONSTANT.MONTH,
        field: "month",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: ESTIMATED_UNBILL_FIGURE_CONSTANT.AMOUNT,
        field: "amount",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        dataType: DECIMAL_2,
        width: 150,
    },

].map((col, index) => {
    const cellRenderers: { [key: string]: ((params: CustomCellRendererProps) => {}) } = {};

    return defineColumn(col, index, dateFieldList, dateTimeFieldList, [], cellRenderers);
});

export const transferRowData = (data: any[]) => {
    const externalFnctions: { [key: string]: ((fieldName: string, row: any) => {}) } = {};

    return transferRowDataInternal(data, dateFieldList, dateTimeFieldList, [], externalFnctions);
}